import React from 'react';
export function Footer() {
  return <footer className="border-t border-navy-800 bg-navy-950 py-12" data-id="element-52">
      <div className="container mx-auto px-4" data-id="element-53">
        <div className="max-w-4xl mx-auto text-center" data-id="element-54">
          <p className="mb-6 font-medium text-gray-400" data-id="element-55">
            © 2026 Basketball Ready: System 365 — All Rights Reserved.
          </p>

          <p className="mx-auto mb-8 max-w-3xl text-sm leading-relaxed text-gray-500" data-id="element-56">
            Basketball Ready: System 365 is an educational coaching resource
            created to support basketball coaches in planning, organizing, and
            delivering practices. It is not a substitute for official coaching
            certification, safeguarding requirements, or governing body
            regulations.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-57">
            <a href="#" className="transition-colors hover:text-gold-500" data-id="element-58">
              Terms & Conditions
            </a>
            <a href="#" className="transition-colors hover:text-gold-500" data-id="element-59">
              Privacy Policy
            </a>
            <a href="#" className="transition-colors hover:text-gold-500" data-id="element-60">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}